import React from "react";

const icon = `${EASYCOMMERCE.assets}admin/img/icons/no-shipping.png`;

const EmptyShipping = ({ handleAddNew }) => {
    return (
        <div className="text-center py-24">
            <img className="mx-auto mb-[30px]" src={icon} alt="" />
            <h2 className="font-inter text-xl mb-6 font-semibold leading-8 text-ec-placeholder">
                No shipping methods configured
            </h2>
            <button
                onClick={handleAddNew}
                className="text-ec-primary font-inter text-base leading-[26px] py-3 px-8 border border-ec-primary rounded-lg hover:text-white hover:bg-ec-primary transition-all 
                        ease-in-out duration-500"
            >
                Add Shipping
            </button>
        </div>
    );
};

export default EmptyShipping;
